export default "__VITE_ASSET__DVP00QCk__"